import type { EventWindowProperties } from '../types';

export const getEventWindowProperties = (): EventWindowProperties => {
  if (typeof window === 'undefined' || !window) return {};
  // Extract window properties
  const { origin, pathname, search } = window?.location || {};
  // Extract params
  const params = search
    ? search
        ?.replace('?', '')
        ?.split('&')
        ?.reduce((obj, param) => {
          const split = param.split('=');
          return {
            [split[0]]: split[1],
            ...obj,
          };
        }, {})
    : null;
  // Return values
  return {
    path: pathname,
    referrer: origin,
    ...(params && { params }),
  };
};
